import {
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { BaseEntryProductComponent } from '@products/base-entry-product-component';
import { Logger } from '@utils/logger';
import { FundAttributionDisplayComponent } from '../fund-attribution-component.interface';
import { FundAttributionConfig } from '../fund-attribution.config';

const logger = Logger.getLogger('FundAttributionEntryComponent');

@Component({
  selector: 'ft-fund-attribution-entry',
  templateUrl: './fund-attribution-entry.component.html',
  styleUrls: ['./fund-attribution-entry.component.scss'],
})
export class FundAttributionEntryComponent
  extends BaseEntryProductComponent
  implements OnInit, OnDestroy {
  componentType: string;
  componentRef: ComponentRef<FundAttributionDisplayComponent>;
  componentConfig: FundAttributionConfig;
  isLoading = true;
  errorMsg: string;

  @ViewChild('dynamicCmp', { read: ViewContainerRef, static: false }) container;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private changeDetector: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.componentType = this.brConfig?.componentType;
    this.componentConfig = FundAttributionConfig.getConfig(
      this.componentType,
      this.configurationName
    );
    this.changeDetector.detectChanges(); // at this point show component if componentType exists

    if (this.componentConfig) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
        this.componentConfig.component
      );

      this.container.clear();
      this.componentRef = this.container.createComponent(componentFactory);
      this.isLoading = false;
      this.errorMsg = null;
      this.componentRef.instance.populate(
        this.componentConfig,
        this.brConfig,
        this.component,
        this.page
      );

      this.changeDetector.detectChanges(); // to remove loading message
    } else {
      logger.error(
        'No component found: ',
        this.componentType,
        this.configurationName
      );

      this.errorMsg = `No component found: ${this.componentType}, ${this.configurationName}`;
    }
  }

  ngOnDestroy(): void {
    // clean up dynamic component to avoid memory leaks
    this.componentRef?.destroy();
  }
}
